import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConnectButton from '../common/ConnectButton';

// Top bar — just brand + connect button. Primary navigation lives in the bottom nav.
const Navbar = () => {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="brand" onClick={() => navigate('/')}>
          <div className="brand-logo">✦</div>
          <span className="brand-name">Dreamlifeway</span>
        </div>
        <ConnectButton />
      </div>
    </nav>
  );
};

export default Navbar;
